import { Injectable } from "@angular/core";
import { LOCAL_STORAGE_KEYS } from "../global/constant";

export interface DeviceInfo {
  user_agent: string;
  platform: string;
  language: string;
  screen_resolution: string;
  color_depth: number;
  timezone: string;
  timezone_offset: number;
  touch_support: boolean;
  hardware_concurrency: number;
  device_memory: number | null;
  fingerprint_hash: string;
}

@Injectable({
  providedIn: "root",
})
export class DeviceFingerprintService {
  private cachedFingerprint: string | null = null;

  getDeviceInfo(): DeviceInfo {
    const info: Omit<DeviceInfo, "fingerprint_hash"> = {
      user_agent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      screen_resolution: `${screen.width}x${screen.height}`,
      color_depth: screen.colorDepth,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezone_offset: new Date().getTimezoneOffset(),
      touch_support: navigator.maxTouchPoints > 0,
      hardware_concurrency: navigator.hardwareConcurrency || 0,
      device_memory: (navigator as any).deviceMemory || null,
    };

    const hash = this.getFingerprint();

    return { ...info, fingerprint_hash: hash };
  }

  getFingerprint(): string {
    if (this.cachedFingerprint) {
      return this.cachedFingerprint;
    }

    const stored = localStorage.getItem(LOCAL_STORAGE_KEYS.device_fingerprint);
    if (stored) {
      this.cachedFingerprint = stored;
      return stored;
    }

    const raw = [
      navigator.userAgent,
      navigator.platform,
      navigator.language,
      `${screen.width}x${screen.height}`,
      screen.colorDepth,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.hardwareConcurrency || 0,
      (navigator as any).deviceMemory || 0,
      navigator.maxTouchPoints,
    ].join("|");

    const hash = this.hashString(raw);
    this.cachedFingerprint = hash;
    localStorage.setItem(LOCAL_STORAGE_KEYS.device_fingerprint, hash);
    return hash;
  }

  clearFingerprint(): void {
    this.cachedFingerprint = null;
    localStorage.removeItem(LOCAL_STORAGE_KEYS.device_fingerprint);
  }

  private hashString(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0;
    }
    return Math.abs(hash).toString(16).padStart(8, "0");
  }
}
